// Nota única do produto arte estendida (D5): condição, sem nota numérica nem subgrades.

export const CONDITIONS = ["M", "NM", "SP", "MP", "HP", "D"];

export const CONDITION_LABELS = {
    M: "Mint",
    NM: "Near Mint",
    SP: "Slightly Played",
    MP: "Moderately Played",
    HP: "Heavily Played",
    D: "Damaged",
};

export const conditionLabel = (code) => CONDITION_LABELS[code] || code || "";
